export const PALETTECOLORS = [
    { label: 'Rojo', value: '#FF0000' },
    { label: 'Azul', value: '#0000FF' },
    { label: 'Verde', value: '#00FF00' },
    { label: 'Amarillo', value: '#FFFF00' },
    { label: 'Blanco', value: '#FFFFFF' },
    { label: 'Negro', value: '#000000' },
    { label: 'Cyan', value: '#00FFFF' },
    { label: 'Magenta', value: '#FF00FF' },
    { label: 'Naranja', value: '#FFA500' },
    { label: 'Violeta', value: '#8A2BE2' },
    { label: 'Rosa', value: '#FFC0CB' },
    { label: 'Gris', value: '#808080' },
    { label: 'Marrón', value: '#A52A2A' },
];
